import script from "./InfopaketHinweise.vue?vue&type=script&setup=true&lang=js"
export * from "./InfopaketHinweise.vue?vue&type=script&setup=true&lang=js"

import "./InfopaketHinweise.vue?vue&type=style&index=0&id=38b02776&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38b02776"]])

export default __exports__